import type { Status } from '../../components/primitives/types'

function isResolvedCompletionStatus(status?: string | null): boolean {
  return status === 'gone' || status === 'false_positive'
}

export function findingVerdictView(status?: string | null): { label: string; tone: Status } {
  switch (status) {
    case 'gone':
      return { label: 'Resolved', tone: 'run' }
    case 'false_positive':
      return { label: 'False positive', tone: 'run' }
    case 'still':
      return { label: 'Still happening', tone: 'warn' }
    case 'reopened':
      return { label: 'Reopened', tone: 'warn' }
    default:
      return { label: 'Open', tone: 'idle' }
  }
}

export function findingVerdictNote(args: {
  status?: string | null
  reason?: string | null
  completedAt?: string | null
  completedAtLabel?: string
}): string {
  const reason = completionReasonLabel(args.reason)
  if (isResolvedCompletionStatus(args.status)) {
    const when = args.completedAtLabel?.trim()
    const kind = args.status === 'false_positive' ? 'false positive' : 'agent verdict'
    return when ? `resolved ${when} · ${kind}` : `resolved · ${kind}`
  }
  if (args.status === 'still') {
    return reason ? `still happening · ${reason}` : 'still happening · agent verdict'
  }
  if (args.status === 'reopened') {
    return reason ? `reopened · ${reason}` : 'reopened · agent verdict'
  }
  return 'open · closing action items does not close the finding'
}

function completionReasonLabel(reason?: string | null): string | undefined {
  switch (reason) {
    case 'still_happening':
      return 'Still happening'
    case 'wrong_triggers':
      return 'Wrong triggers'
    case 'wrong_actions':
      return 'Wrong actions'
    default:
      return reason?.trim() || undefined
  }
}
